import LogRocket from "logrocket";
import { version } from "../../package.json";
import setupLogRocketReact from "logrocket-react";

export let logRocketSessionUrl: string | null = null;

export const initializeLogRocket = () => {
  if (shouldAddLogRocket()) {
    // Initialize LogRocket
    LogRocket.init("tvewer/rooster-external", {
      release: `external-${version}`
    });
    setupLogRocketReact(LogRocket);

    // Add console logging to capture logs
    LogRocket.getSessionURL((sessionURL) => {
      if (sessionURL) {
        logRocketSessionUrl = sessionURL;
        console.log("LogRocket session URL:", sessionURL);
      }
    });
  }
};

const shouldAddLogRocket = () => {
  return import.meta.env.VITE_ADD_LOGROCKET === "true";
};

// Export LogRocket instance for use in other parts of the app
export default LogRocket;
